module.exports = __webpack_public_path__ + "img/O_talk.d4672998.gif";